import assertNever from 'assert-never';
import isIConditional from './isIConditional';
import isIDirect from './isIDirect';
import isIRandom from './isIRandom';
import isIRemote from './isIRemote';
import Conditional from './Conditional';
import Direct from './Direct';
import Random from './Random';
import Remote from './Remote';
export function linkFactory(link) {
    if (isIConditional(link)) {
        return new Conditional(link);
    } else if (isIDirect(link)) {
        return new Direct(link);
    } else if (isIRandom(link)) {
        return new Random(link);
    } else if (isIRemote(link)) {
        return new Remote(link);
    } else {
        return assertNever(link);
    }
}
export {
    linkFactory as factory
};
export default linkFactory;    //# sourceMappingURL=factory.js.map
